import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const GameCodeLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.game_code',
    link: '/code/gamecode/list',
    icon: 'navigation-link__list-item',
});